import { decode } from 'js-base64';

export const useSurveyNotificationData = (notification = {}) => {
  const { custom_attributes } = notification;

  let data = {};
  try {
    data = JSON.parse(decode(custom_attributes));
  } catch (error) {
    console.error('Error decoding survey notification attributes:', error);
  }

  const { survey = {}, candidate = {}, job = {} } = data;

  const {
    id: surveyId,
    name: surveyName,
    url: surveyUrl,
    sent_by: sentBy = {},
    sent_at: sentAt,
    submission_id,
    survey_id,
    nps_score,
    participant_type,
    submission_link,
  } = survey;

  const { id: candidateId, name: candidateName, url: candidateUrl } = candidate;

  const { name: jobName, url: jobUrl } = job;

  return {
    survey: {
      id: surveyId,
      name: surveyName,
      url: surveyUrl,
      sentBy,
      sentAt,
      submissionId: submission_id,
      surveyId: survey_id,
      npsScore: nps_score,
      participantType: participant_type,
      submission_link,
    },
    candidate: {
      id: candidateId,
      name: candidateName,
      url: candidateUrl,
    },
    job: {
      name: jobName,
      url: jobUrl,
    },
  };
};
